module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar card-sidebar-mini",
    staticStyle: {
      "position": "fixed",
      "width": "6.5%",
      "height": "99vh",
      "bottom": "0px",
      "left": "0px",
      "background": "#ffffff",
      "border-top-left-radius": "18px",
      "z-index": "10000",
      "padding": "1em 10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-sidebar-body"
  }, [_c('div', {
    staticClass: "card-sidebar-group-x"
  }, [_c('div', [(_vm.site_user_type == 2) ? _c('li', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 2) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "card-sidebar-footer",
    staticStyle: {
      "position": "fixed",
      "bottom": "10px",
      "display": "none"
    }
  }, [_c('div', {}, [_vm._m(8), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "none"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_vm._v("last seen: Yesterday")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "href": "/manage/profile"
    }
  }, [_vm._v("View Profile")])])])]), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar-headx"
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "12px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/brand001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "8px",
      "text-align": "left",
      "color": "#ff0000"
    }
  }, [_vm._v("easy-peasy")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fas fa-table"
  }), _c('span', [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/search"
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _c('span', [_c('br'), _vm._v("Order From")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/orders"
    }
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _c('span', [_c('br'), _vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/placed/orders"
    }
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _c('span', [_c('br'), _vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _c('span', [_c('br'), _vm._v("Favorites")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar-group-x",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('div', [_c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/settings"
    }
  }, [_c('i', {
    staticClass: "fas fa-gear"
  }), _c('span', [_c('br'), _vm._v("Settings")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _c('span', [_c('br'), _vm._v("Notifications")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-support"
  }), _c('span', [_c('br'), _vm._v("Support")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar-group-x",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', [_c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-power-off"
  }), _c('span', [_c('br'), _vm._v("Log out")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-circle-xx",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "11px",
      "text-align": "center"
    }
  }, [_vm._v("© 2023 "), _c('br'), _vm._v(" Place Order")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00239f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DesktopViews/SidebarMini.vue
// module id = 524
// module chunks = 0